<template>
    <transition appear name="fade-transition">
        <div class="app-table-footer" :class="{ 'justify-center': lazyLoad }">
            <div v-if="!lazyLoad" class="d-flex align-center">
                <v-select
                    v-model="itemsPerPageValue"
                    color="primaryText"
                    background-color="background"
                    dense
                    outlined
                    hide-details
                    :title="$t('items_per_page')"
                    :items="[10, 40, 100]"
                    :disabled="disabled"
                    style="width: min-content; font-size: 1rem"
                />
                <span class="ml-2">{{ $t('items_per_page') }}</span>
            </div>

            <div class="d-flex align-center">
                <div v-if="total">
                    <span>{{ getPaginatedItemsFrom() }}</span>
                    <span>-</span>
                    <span>{{ getPaginatedItemsTo() }}</span>
                    <span class="mx-1">of</span>
                    <span>{{ total }} {{ $t('items') }}</span>
                </div>

                <v-spacer v-if="canLoadMore" class="mx-4" />

                <app-button
                    v-if="lazyLoad && canLoadMore"
                    v-test-id="{ action: 'load_more' }"
                    secondary
                    :text="$t('load_more')"
                    :icon="getIcon('moreDown', 'fad')"
                    :title="$t('load_more')"
                    :loading="loading"
                    @click.stop="pageValue++"
                />
            </div>

            <div v-if="!lazyLoad" class="d-flex align-center">
                <template v-if="getPageCount()">
                    <span>{{ $t('page') }}</span>
                    <v-select
                        v-model="pageValue"
                        color="primaryText"
                        background-color="background"
                        dense
                        outlined
                        hide-details
                        :title="$t('page_number')"
                        :items="_.range(1, getPageCount() + 1, 1)"
                        :disabled="!hasPages || disabled"
                        style="width: min-content; font-size: 1rem"
                        class="mx-2"
                    ></v-select>
                    <span>{{ $t('of') }} {{ getPageCount() }}</span>
                </template>
                <v-spacer class="mx-3"></v-spacer>
                <app-button
                    v-test-id="{ action: 'previous' }"
                    icon="prev"
                    :title="$t('previous_page')"
                    :disabled="pageValue === 1 || disabled"
                    @click="pageValue--"
                />
                <app-button
                    v-test-id="{ action: 'next' }"
                    icon="next"
                    :title="$t('next_page')"
                    :disabled="!canLoadMore || disabled"
                    @click="pageValue++"
                />
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'TableFooter',
    props: {
        itemsPerPage: {
            type: Number,
            required: true
        },
        page: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        lazyLoad: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        itemsPerPageValue: {
            get() {
                return this.itemsPerPage;
            },
            set(v) {
                this.$emit('update-options', { itemsPerPage: v });
            }
        },
        pageValue: {
            get() {
                return this.page;
            },
            set(v) {
                this.$emit('update-options', { page: v });
            }
        },
        hasPages() {
            return this.getPageCount() > 1;
        },
        canLoadMore() {
            return this.pageValue !== this.getPageCount();
        }
    },
    methods: {
        getPageCount() {
            return Math.ceil(this.total / this.itemsPerPage);
        },
        getPaginatedItemsFrom() {
            let from = 1;

            if (this.lazyLoad) {
                return from;
            }

            if (this.pageValue > 1) {
                from = (this.pageValue - 1) * this.itemsPerPage;
            }

            return from;
        },
        getPaginatedItemsTo() {
            let to = this.itemsPerPage;

            if (this.pageValue > 1) {
                to = this.pageValue * this.itemsPerPage;
            }

            if (to > this.total) {
                to = this.total;
            }

            return to;
        }
    }
};
</script>
